"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const schedulo_1 = require("./schedulo");
const dymo_core_1 = require("dymo-core");
const players_1 = require("./players");
const superstore_service_1 = require("./worker-store/superstore-service");
const dymo_core_2 = require("dymo-core");
/**
 * A class for easy access of all dymo player functionality.
 */
class DymoPlayer {
    constructor(useWorkers, preloadBuffers = true, scheduleAheadTime = 1, loadAheadTime = 3, fadeLength = 0.01, fetcher, loggingOn = false) {
        this.preloadBuffers = preloadBuffers;
        this.scheduleAheadTime = scheduleAheadTime;
        this.loadAheadTime = loadAheadTime;
        this.fadeLength = fadeLength;
        this.loggingOn = loggingOn;
        const workerStore = useWorkers ? new superstore_service_1.WorkerStoreService(fetcher) : null;
        this.dymoManager = new dymo_core_2.DymoManager(workerStore, fetcher);
    }
    init(ontologiesPath) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggingOn)
                console.log("INIT PLAYER");
            yield this.dymoManager.init(ontologiesPath);
            this.schedulo = new schedulo_1.ScheduloScheduler(this.scheduleAheadTime, this.loadAheadTime, this.fadeLength);
            this.player = new players_1.MultiPlayer(this.dymoManager.getStore(), this.schedulo, this.loggingOn);
        });
    }
    loadDymo(...fileUris) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggingOn)
                console.log("LOADING", ...fileUris);
            const loaded = yield this.dymoManager.loadIntoStore(...fileUris);
            if (this.preloadBuffers) {
                const paths = yield this.dymoManager.getStore().getAllSourcePaths();
                yield this.schedulo.getAudioBank().preloadBuffers(paths);
            }
            if (this.loggingOn)
                console.log("DONE LOADING");
            if (this.loggingOn)
                console.log("store size", yield this.dymoManager.getStore().size());
            return loaded;
        });
    }
    loadDymoFromString(dymo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggingOn)
                console.log("LOADING");
            const loaded = yield this.dymoManager.loadIntoStoreFromString(dymo);
            if (this.preloadBuffers) {
                const paths = yield this.dymoManager.getStore().getAllSourcePaths();
                yield this.schedulo.getAudioBank().preloadBuffers(paths);
            }
            if (this.loggingOn)
                console.log("DONE LOADING");
            if (this.loggingOn)
                console.log("store size", yield this.dymoManager.getStore().size());
            return loaded;
        });
    }
    getDymoManager() {
        return this.dymoManager;
    }
    getPlayingDymoUris() {
        if (this.player) {
            return this.player.getPlayingDymoUris();
        }
    }
    getAudioBank() {
        if (this.player) {
            return this.player.getAudioBank();
        }
    }
    isPlaying(dymoUri) {
        return this.player ? this.player.isPlaying(dymoUri) : false;
    }
    getPosition(dymoUri) {
        if (this.player) {
            return this.player.getPosition(dymoUri);
        }
    }
    playUri(dymoUri, afterUri) {
        if (this.loggingOn)
            console.log("PLAYING", dymoUri);
        return this.player.play(this.addContext(dymoUri), afterUri);
    }
    stopUri(dymoUri) {
        return this.player.stop(this.addContext(dymoUri));
    }
    play() {
        if (this.schedulo.isPaused()) {
            this.schedulo.pause();
        }
        else {
            const rendering = this.dymoManager.getRendering();
            if (rendering) {
                this.playUri(rendering.getDymoUri());
            }
            else {
                this.dymoManager.getLoadedDymoUris().forEach(d => this.playUri(d));
            }
        }
    }
    pause() {
        this.schedulo.pause();
    }
    stop() {
        return __awaiter(this, void 0, void 0, function* () {
            const rendering = this.dymoManager.getRendering();
            if (rendering) {
                yield this.stopUri(rendering.getDymoUri());
            }
            else {
                yield Promise.all(this.dymoManager.getLoadedDymoUris().map(d => this.stopUri(d)));
            }
            if (this.schedulo.isPaused()) {
                this.schedulo.pause();
            }
        });
    }
    addContext(uri) {
        return uri.indexOf(dymo_core_1.uris.CONTEXT_URI) < 0 ? dymo_core_1.uris.CONTEXT_URI + uri : uri;
    }
}
exports.DymoPlayer = DymoPlayer;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/main.js
// module id = 1314
// module chunks = 3